import { render, staticRenderFns } from "./FoodSamplesTable.vue?vue&type=template&id=2fa7d926"
import script from "./FoodSamplesTable.vue?vue&type=script&lang=js"
export * from "./FoodSamplesTable.vue?vue&type=script&lang=js"
import style0 from "./FoodSamplesTable.vue?vue&type=style&index=0&id=2fa7d926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports